/*
 * Project: BookingEngine
 * Module: components/icons/highlights/BedIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const BedIcon = () => (
  <svg className="svg-icon highlight-bed-icon" width="32px" height="30px" viewBox="0 0 32 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="50%" y1="100%" x2="50%" y2="-1.74574067e-13%" id="linearGradient-1">
        <stop stopColor="#000000" stopOpacity="0" offset="0%"/>
        <stop stopColor="#000000" offset="100%"/>
      </linearGradient>
    </defs>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/facilities/bed-3" transform="translate(-4.000000, -5.000000)">
        <g id="Group" transform="translate(4.000000, 5.000000)">
          <path d="M3.34164079,22.4472136 L4.4472136,21.8944272 L3,21 L3,22.5 L3,22 L2.65835921,22.5527864 L1.5527864,
            23.1055728 L3,24 L3,22.5 L3,23 L3.34164079,22.4472136 Z" stroke="#E0430D" strokeWidth="2"/>
          <path d="M29.3416408,20.5527864 L29,20 L29,20.5 L29,19 L27.5527864,19.8944272 L28.6583592,20.4472136 L29,
            21 L29,20.5 L29,22 L30.4472136,21.1055728 L29.3416408,20.5527864 Z" stroke="#E0430D" strokeWidth="2"/>
          <polygon fill="#ED871A"
                   points="0 19 16 11 16 1 18 0 32 7 32 21 30 22 30 20 16 27 16 29 14 30 12 29 12 27 2 22 2 24 0 23"/>
          <polygon fill="#F8E71C" points="16 8 30 15 30 18 14 26 0 19 0 16"/>
          <polygon fill="#18BAB7" points="14 15 22 19 22 22 14 26 0 19 0 16 2 15"/>
          <polygon fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }} points="2 15 14 15 8 20"/>
          <polygon fill="#18BAB7" points="2 15 14 15 8 18"/>
          <polygon fill="#000000" style={{ mixBlendMode: 'overlay' }} points="30 15 30 18 14 26 14 23"/>
          <path
            d="M31,14.5 L31,21 L31.5527864,20.1055728 L29.5527864,21.1055728 L31,22 L31,14.5 Z M31,14.5 L31,
            8 L30.4472136,8.89442719 L32.4472136,7.89442719 L31,7 L31,14.5 Z" stroke="#E45A11" strokeWidth="2"/>
          <path
            d="M29,19.618034 L29,20 L29.3416408,19.4472136 L30.4472136,18.8944272 L29,18 L29,19.381966 L15,
            26.381966 L15,28 L15,26 L14.4472136,26.8944272 L29,19.618034 Z M15,28 L15,29 L15.5527864,
            28.1055728 L13.5527864,29.1055728 L15,30 L15,28 Z" stroke="#E45A11" strokeWidth="2"/>
          <polygon fill="#18BAB7" points="18 5 22 7 22 11 20 12 16 10 16 6"/>
          <polygon fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }}
                   opacity="0.600000024" points="22 7 22 11 20 12 20 8"/>
          <polygon fill="#18BAB7" points="24 8 28 10 28 14 26 15 22 13 22 9"/>
          <polygon fill="url(#linearGradient-1)" style={{ mixBlendMode: 'overlay' }}
                   opacity="0.600000024" points="28 10 28 14 26 15 26 11"/>
          <polygon fill="#F5FAFD" points="22 11 26 13 26 15 24 16 20 14 20 12"/>
          <polygon fill="#F5FAFD" points="16 8 20 10 20 12 18 13 14 11 14 9"/>
          <polygon fill="url(#linearGradient-1)" opacity="0.200000003" points="26 13 26 15 24 16 24 14"/>
          <polygon fill="url(#linearGradient-1)" opacity="0.200000003" points="20 10 20 12 18 13 18 11"/>
        </g>
      </g>
    </g>
  </svg>
);

export default BedIcon;
